module.exports = __webpack_public_path__ + "img/electronic_pending_zone.c1b897cb.svg";